import buildUrl from 'build-url';
import queryString from 'query-string';
import { convertListingPageStateToUrl } from './components/ListingPage/services/listingPageUrlService';
import { PageType } from './hooks/UrlManager/types';
import { ListingPageUrlState } from './redux/products/types';

const defaultListingPageState = { page: 1, appliedFilters: [], listingPageKey: '', sortingParams: {}, query: {} };

type UrlStateParam = Partial<ListingPageUrlState> & Pick<ListingPageUrlState, 'listingPageType'>;

export const getListingPageUrl = (urlState: UrlStateParam, host: string = '') =>
    convertListingPageStateToUrl({ ...defaultListingPageState, ...urlState }, host);

export const getNewProductsUrl = (host: string = '') =>
    getListingPageUrl({ listingPageType: PageType.NEWPRODUCTS }, host);

export const getAllProductsUrl = (search: string | undefined = undefined, host: string = '') =>
    getListingPageUrl({ listingPageType: PageType.ALLPRODUCTS, search }, host);

export const getBrandsUrl = (brandKey: string, host: string = '') =>
    getListingPageUrl({ listingPageType: PageType.BRANDS, listingPageKey: brandKey }, host);

export const getCategoriesUrl = (categoryKey: string, host: string = '') =>
    getListingPageUrl(
        {
            listingPageType: PageType.CATEGORY,
            listingPageKey: categoryKey,
        },
        host
    );

export const trimTrailingSlash = (url: string): string => (url.endsWith('/') ? url.slice(0, url.length - 1) : url);
export const ensureEndingSlash = (url: string): string => `${trimTrailingSlash(url)}/`;

export const getQueryParamValue = (url: string, queryParamKey: string): string => {
    const parsedUrl = queryString.parseUrl(url);
    return (parsedUrl.query[queryParamKey] || '') as string;
};

export const getLooksUrl = (urlKey: string = '', host: string = '') => {
    const looksBaseUrl = `${host}/looks/`;
    if (!urlKey) {
        return looksBaseUrl;
    }
    return `${looksBaseUrl}${trimTrailingSlash(urlKey)}/`;
};

export const getAddonProductsUrl = (configSku: string, simpleSku: string, host: string = '') =>
    buildUrl(host, { path: 'catalog/promotion/', queryParams: { configSku, simpleSku } });

// Implementation taken from Alice.
export const extractVimeoIdFromUrl = (vimeoVideoUrl?: string) => {
    if (!vimeoVideoUrl) {
        return '';
    }
    return trimTrailingSlash(vimeoVideoUrl).split('/').pop() || '';
};

export const getVimeoPlayerUrl = (vimeoId: string) => (vimeoId ? `https://player.vimeo.com/video/${vimeoId}` : '');
